// config
import * as http from 'utils/http';
import config from 'config';

const closeAuctions = async ({ routeId }) => {
  return http.post(`${config.API_URL}fleet/routes/${routeId}/close_auctions/`);
};

export default closeAuctions;
